var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 0.25C0.921573 0.25 0.25 0.921573 0.25 1.75L0.25 12.25C0.25 13.0784 0.921573 13.75 1.75 13.75H12.25C13.0784 13.75 13.75 13.0784 13.75 12.25V1.75C13.75 0.921573 13.0784 0.25 12.25 0.25L1.75 0.25ZM4 4.75L7 1.75L10 4.75H7.75V8.5C7.75 9.25 7.75 9.25 7 9.25C6.25 9.25 6.25 9.25 6.25 8.5V4.75H4ZM2.5 12.25C2.08579 12.25 1.75 11.9142 1.75 11.5V10H3.25V10.375C3.25 10.5821 3.41789 10.75 3.625 10.75H10.375C10.5821 10.75 10.75 10.5821 10.75 10.375V10H12.25V11.5C12.25 11.9142 11.9142 12.25 11.5 12.25H2.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.afd946d533e9d2adbded8380dbb19601.svg";
export { ForwardRef as ReactComponent };